import { render, staticRenderFns } from "./GoodToKnow.vue?vue&type=template&id=23d27d18&"
import script from "./GoodToKnow.vue?vue&type=script&lang=js&"
export * from "./GoodToKnow.vue?vue&type=script&lang=js&"
import style0 from "./GoodToKnow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports